import { Container } from "react-bootstrap";

const AndroidCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">
                        End-to-End Android Application for Field Workforce Management
                    </h2>

                    <h3 className="text-primary ft-wt-700 mb-3">The Challenge</h3>

                    <p>
                        A logistics company needed a mobile application to manage its field
                        workforce, track deliveries, and optimize dispatch operations. Their
                        existing manual process relied heavily on paper records and phone
                        communication, leading to frequent delays, inefficient routing, and
                        lack of real-time data. The absence of centralized visibility into
                        delivery status and workforce productivity was affecting both
                        customer satisfaction and operational costs.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Solution</h3>

                    <p>
                        We developed a native Android application tailored for field
                        personnel, integrated with the company's backend systems. The app
                        enabled delivery agents to receive tasks, update statuses, capture
                        signatures, scan barcodes, and navigate via maps — all from their
                        mobile devices. We implemented background sync for offline support,
                        push notifications for real-time updates, and role-based access
                        controls for administrators. A web-based dashboard was also
                        delivered to monitor field activity in real time.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Benefits</h3>

                    <p>Key advantages achieved with the solution include:</p>
                    <ul>
                        <li>Real-time task tracking and status updates</li>
                        <li>Improved delivery success rate and agent productivity</li>
                        <li>Offline functionality ensured uninterrupted usage in low-signal areas</li>
                        <li>Enhanced customer experience with accurate ETAs and delivery proofs</li>
                        <li>Streamlined reporting and reduced paperwork</li>
                    </ul>
                </div>
            </Container>
        </section>
    );
};

export default AndroidCaseStudy;
